'use strict';
module.exports = require('./Column.vue');